module.exports = __webpack_public_path__ + "static/img/icon_accesos.34741289.svg";